export default "__VITE_ASSET__DHNhBVxU__"